module.exports = __webpack_public_path__ + "img/area_keterlambatan.2b298d32.svg";